import Entity from 'utilities/entity';

class Feedback extends Entity {

}

export default new Feedback();